import React, { Suspense, useRef } from 'react'
import { connect } from 'react-redux'
import { Routes, Route, Navigate } from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import PropTypes from 'prop-types'
import Layout from '../layouts'
import PrivateRoute from './PrivateRoute'
import routes from './routes'

const mapStateToProps = ({ router, settings }) => ({
  location: router.location,
  routerAnimation: settings.routerAnimation
})

// TODO: Check if anything works as expected

const Router = ({ location, routerAnimation }) => {
  const nodeRef = useRef(null)
  return (
    <Layout>
      <SwitchTransition>
        <CSSTransition
          key={location.key}
          nodeRef={nodeRef}
          appear
          classNames={routerAnimation}
          timeout={routerAnimation === 'none' ? 0 : 300}
        >
          <div ref={nodeRef}>
            <Routes location={location}>
              <Route path="/" element={<Navigate to="/dashboards/activity" />} />
              {routes.map(({ path, Component, secured }) =>
                secured ? (
                  <Route
                    path={path}
                    key={path}
                    element={
                      <PrivateRoute>
                        <div className={routerAnimation}>
                          <Suspense fallback={null}>
                            <Component />
                          </Suspense>
                        </div>
                      </PrivateRoute>
                    }
                  />
                ) : (
                  <Route
                    path={path}
                    key={path}
                    element={
                      <div className={routerAnimation}>
                        <Suspense fallback={null}>
                          <Component />
                        </Suspense>
                      </div>
                    }
                  />
                )
              )}
              <Route path="*" element={<Navigate to="/auth/404" />} />
            </Routes>
          </div>
        </CSSTransition>
      </SwitchTransition>
    </Layout>
  )
}

Router.propTypes = {
  location: PropTypes.object.isRequired,
  routerAnimation: PropTypes.string.isRequired
}

export default connect(mapStateToProps)(Router)
